import _debounce from 'underscore/modules/debounce';
import PopulatorFactory from '../factories/populator-factory.js';
import ValidatorFactory from '../factories/validator-factory.js';
import PromiseReducer from '../helpers/promise-reducer.js';

export default class FormInput {
    constructor(parent, el) {
        this.parent = parent;
        this.form = parent.form;
        this.el = el;
        this.type = el.type;
        this.validators = ValidatorFactory.build(this);
        this.populators = PopulatorFactory.build(this);
        this.bind();
    }

    id() {
        return this.el.dataset.id;
    }

    value() {
        return this.el.value;
    }

    bind() {
        if (this.type === 'checkbox' || this.type === 'radio' || this.el.tagName === 'SELECT') {
            this.el.addEventListener('change', this.update.bind(this));
            this.el.addEventListener('blur', this.update.bind(this));
        } else {
            this.el.addEventListener('blur', this.update.bind(this));
            this.el.addEventListener('input', this.update.bind(this));
            this.el.addEventListener('change', this.update.bind(this));
        }
    }

    reset() {
        this.el.value = null;
    }

    disabled() {
        return this.parent.disabled();
    }

    update = _debounce(() => this.parent.update(), 100, true);

    valid() {
        return PromiseReducer.all(this.validators.map((v) => v.valid()));
    }

    focus() {
        this.el.focus();
    }

    populated() {
        return PromiseReducer.all(this.validators.filter((v) => ValidatorFactory.isMandatory(v)).map((v) => v.valid()));
    }

    populate() {
        this.populators.forEach((p) => p.populate());
    }
}
